import tw, { styled } from 'twin.macro'

export const GridRoot = styled.div`
   ${tw`container w-full`}
`